import i18n from "../../i18n";
import moment from "moment";

const periods = {
  /* last_30_minute: {
    value: "last_30_minute",
    label: i18n.t("last_minute", { count: 30 }),
    start: () => moment().subtract(30, "m"),
    end: () => moment(),
  }, */
  last_1_hour: {
    value: "last_1_hour",
    label: i18n.t("last_hour", { count: 1 }),
    start: () => moment().subtract(59, "m").startOf("m"),
    end: () => moment().startOf("m"),
  },
  /* last_6_hour: {
    value: "last_6_hour",
    label: i18n.t("last_hour", { count: 6 }),
    start: () => moment().subtract(6, "h"),
    end: () => moment(),
  },
  this_day: {
    value: "this_day",
    label: i18n.t("this_day"),
    start: () => moment().startOf("d"),
    end: () => moment().endOf("d"),
  }, */
  last_24_hour: {
    value: "last_24_hour",
    label: i18n.t("last_hour", { count: 24 }),
    start: () => moment().subtract(23, "h").startOf("h"),
    end: () => moment().endOf("h"),
  },
  /* prev_day: {
    value: "prev_day",
    label: i18n.t("prev_day"),
    start: () => moment().subtract(1, "d").startOf("d"),
    end: () => moment().subtract(1, "d").endOf("d"),
  },
  this_week: {
    value: "this_week",
    label: i18n.t("this_week"),
    start: () => moment().startOf("w"),
    end: () => moment().endOf("w"),
  }, */
  last_7_day: {
    value: "last_7_day",
    label: i18n.t("last_day", { count: 7 }),
    start: () => moment().subtract(6, "d").startOf("d"),
    end: () => moment().endOf("d"),
  },
  /* prev_week: {
    value: "prev_week",
    label: i18n.t("prev_week"),
    start: () => moment().subtract(1, "w").startOf("w"),
    end: () => moment().subtract(1, "w").endOf("w"),
  },
  this_month: {
    value: "this_month",
    label: i18n.t("this_month"),
    start: () => moment().startOf("M"),
    end: () => moment().endOf("M"),
  }, */
  last_30_day: {
    value: "last_30_day",
    label: i18n.t("last_day", { count: 30 }),
    start: () => moment().subtract(29, "d").startOf("d"),
    end: () => moment().endOf("d"),
  },
  /* prev_month: {
    value: "prev_month",
    label: i18n.t("prev_month"),
    start: () => moment().subtract(1, "M").startOf("M"),
    end: () => moment().subtract(1, "M").endOf("M"),
  }, */
};

const defaultPeriod = "last_24_hour";

export { periods, defaultPeriod };
